import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "Here we describe stepwise how to design a listening experiment. Such an experiment is usually created in order to check a hypothesis, which is based on an initial observeration. Each step requires decisions of the experiment designer.",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 3,
      rowsSize: [1, 4, 2],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "<b>Generate a hypothesis</b>",
                  formatter: "html",
                  scrollbars: false,
                },
              },
              styles: {
                fontSize: "18px",
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/02/23/principle/principle-2-content.svg`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "hint",
                options: {
                  data:
                    "<strong>Statistical hypothesis testing</strong> always requires an alternative hypothesis (‘there is a relation’) and a null hypothesis (‘there is no relation’). They are linked to a pre-specified <strong>significance level</strong>, which describes the probability threshold that the data confirms the null hypothesis. If the data evaluation leads to a lower probability, the null hypothesis is rejected and the alternative hypothesis is accepted.",
                  size: "large-thin",
                  color: "primary",
                  direction: "row",
                },
              },
              styles: {
                padding: "1% 0 5% 0",
                maxWidth: "70%",
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
